import {
  TIME_REGISTRATION_POLICY__DESC_ALLOW_START_IN_FUTURE,
  TIME_REGISTRATION_POLICY__DESC_AUTO_FREEZE,
  TIME_REGISTRATION_POLICY__DESC_BREAK_ROUNDING,
  TIME_REGISTRATION_POLICY__DESC_EXTENDED_WINDOW,
  TIME_REGISTRATION_POLICY__DESC_KIOSK_AUTH_MODE,
  TIME_REGISTRATION_POLICY__DESC_KIOSK_AVAILABILITY,
  TIME_REGISTRATION_POLICY__DESC_LOCATION_CAPTURE,
  TIME_REGISTRATION_POLICY__DESC_MAX_BREAKS,
  TIME_REGISTRATION_POLICY__DESC_OVERWORK_LIMIT,
  TIME_REGISTRATION_POLICY__DESC_PERSONAL_DEVICE_BLOCK,
  TIME_REGISTRATION_POLICY__DESC_REGISTRATION_WINDOW,
  TIME_REGISTRATION_POLICY__DESC_START_END_ROUNDING,
  TIME_REGISTRATION_POLICY__FIELD_BREAK_END,
  TIME_REGISTRATION_POLICY__FIELD_BREAK_START,
  TIME_REGISTRATION_POLICY__FIELD_END_TIME,
  TIME_REGISTRATION_POLICY__FIELD_LIMIT_OVERWORK,
  TIME_REGISTRATION_POLICY__FIELD_REQUIRE_LOCATION,
  TIME_REGISTRATION_POLICY__FIELD_ROUND_BREAK_TIMES,
  TIME_REGISTRATION_POLICY__FIELD_ROUND_START_END,
  TIME_REGISTRATION_POLICY__FIELD_START_TIME,
  TIME_REGISTRATION_POLICY__KIOSK_NOTE,
  TIME_REGISTRATION_POLICY__SECTION_KIOSK,
  TIME_REGISTRATION_POLICY__SECTION_LOCATION,
  TIME_REGISTRATION_POLICY__SECTION_POLICY,
  TIME_REGISTRATION_POLICY__UNIT_ALLOW_START_IN_FUTURE,
  TIME_REGISTRATION_POLICY__UNIT_AUTO_FREEZE,
  TIME_REGISTRATION_POLICY__UNIT_BREAK_ROUNDING,
  TIME_REGISTRATION_POLICY__UNIT_EXTENDED_WINDOW,
  TIME_REGISTRATION_POLICY__UNIT_KIOSK_AUTH_MODE,
  TIME_REGISTRATION_POLICY__UNIT_KIOSK_AVAILABILITY,
  TIME_REGISTRATION_POLICY__UNIT_LOCATION_CAPTURE,
  TIME_REGISTRATION_POLICY__UNIT_MAX_BREAKS,
  TIME_REGISTRATION_POLICY__UNIT_OVERWORK_LIMIT,
  TIME_REGISTRATION_POLICY__UNIT_PERSONAL_DEVICE_BLOCK,
  TIME_REGISTRATION_POLICY__UNIT_REGISTRATION_WINDOW,
  TIME_REGISTRATION_POLICY__UNIT_START_END_ROUNDING,
  TIME_REGISTRATION_SETTINGS__ALLOW_BEFORE_PLANNED_START,
  TIME_REGISTRATION_SETTINGS__ALLOW_BEFORE_PLANNED_START_HELPER,
} from 'translations/constants';
import { PolicyUnit } from 'types/time-registration-policy/ITimeRegistrationPolicy';

export type PolicySection = 'policy' | 'location' | 'kiosk';
export type UnitKind = 'toggle' | 'window' | 'number' | 'rounding' | 'overwork' | 'location' | 'authMode';

export interface UnitDefinition {
  unit: PolicyUnit;
  section: PolicySection;
  kind: UnitKind;
  nameKey: string;
  descKey: string;
  toggleLabelKey?: string;
  startLabelKey?: string;
  endLabelKey?: string;
  kiosk?: boolean;
}

export const POLICY_SECTIONS: { section: PolicySection; titleKey: string; noteKey?: string }[] = [
  { section: 'policy', titleKey: TIME_REGISTRATION_POLICY__SECTION_POLICY },
  { section: 'location', titleKey: TIME_REGISTRATION_POLICY__SECTION_LOCATION },
  {
    section: 'kiosk',
    titleKey: TIME_REGISTRATION_POLICY__SECTION_KIOSK,
    noteKey: TIME_REGISTRATION_POLICY__KIOSK_NOTE,
  },
];

export const UNIT_DEFINITIONS: UnitDefinition[] = [
  {
    unit: PolicyUnit.AllowRegistrationBeforePlannedStart,
    section: 'policy',
    kind: 'toggle',
    nameKey: TIME_REGISTRATION_SETTINGS__ALLOW_BEFORE_PLANNED_START,
    descKey: TIME_REGISTRATION_SETTINGS__ALLOW_BEFORE_PLANNED_START_HELPER,
  },
  {
    unit: PolicyUnit.AllowStartInFuture,
    section: 'policy',
    kind: 'toggle',
    nameKey: TIME_REGISTRATION_POLICY__UNIT_ALLOW_START_IN_FUTURE,
    descKey: TIME_REGISTRATION_POLICY__DESC_ALLOW_START_IN_FUTURE,
  },
  {
    unit: PolicyUnit.RegistrationWindow,
    section: 'policy',
    kind: 'window',
    nameKey: TIME_REGISTRATION_POLICY__UNIT_REGISTRATION_WINDOW,
    descKey: TIME_REGISTRATION_POLICY__DESC_REGISTRATION_WINDOW,
  },
  {
    unit: PolicyUnit.ExtendedRegistrationWindow,
    section: 'policy',
    kind: 'window',
    nameKey: TIME_REGISTRATION_POLICY__UNIT_EXTENDED_WINDOW,
    descKey: TIME_REGISTRATION_POLICY__DESC_EXTENDED_WINDOW,
  },
  {
    unit: PolicyUnit.MaximumNumberOfBreaks,
    section: 'policy',
    kind: 'number',
    nameKey: TIME_REGISTRATION_POLICY__UNIT_MAX_BREAKS,
    descKey: TIME_REGISTRATION_POLICY__DESC_MAX_BREAKS,
  },
  {
    unit: PolicyUnit.BreakRounding,
    section: 'policy',
    kind: 'rounding',
    nameKey: TIME_REGISTRATION_POLICY__UNIT_BREAK_ROUNDING,
    descKey: TIME_REGISTRATION_POLICY__DESC_BREAK_ROUNDING,
    toggleLabelKey: TIME_REGISTRATION_POLICY__FIELD_ROUND_BREAK_TIMES,
    startLabelKey: TIME_REGISTRATION_POLICY__FIELD_BREAK_START,
    endLabelKey: TIME_REGISTRATION_POLICY__FIELD_BREAK_END,
  },
  {
    unit: PolicyUnit.StartEndRounding,
    section: 'policy',
    kind: 'rounding',
    nameKey: TIME_REGISTRATION_POLICY__UNIT_START_END_ROUNDING,
    descKey: TIME_REGISTRATION_POLICY__DESC_START_END_ROUNDING,
    toggleLabelKey: TIME_REGISTRATION_POLICY__FIELD_ROUND_START_END,
    startLabelKey: TIME_REGISTRATION_POLICY__FIELD_START_TIME,
    endLabelKey: TIME_REGISTRATION_POLICY__FIELD_END_TIME,
  },
  {
    unit: PolicyUnit.OverworkLimit,
    section: 'policy',
    kind: 'overwork',
    nameKey: TIME_REGISTRATION_POLICY__UNIT_OVERWORK_LIMIT,
    descKey: TIME_REGISTRATION_POLICY__DESC_OVERWORK_LIMIT,
    toggleLabelKey: TIME_REGISTRATION_POLICY__FIELD_LIMIT_OVERWORK,
  },
  {
    unit: PolicyUnit.AutoFreezeOnClockOut,
    section: 'policy',
    kind: 'toggle',
    nameKey: TIME_REGISTRATION_POLICY__UNIT_AUTO_FREEZE,
    descKey: TIME_REGISTRATION_POLICY__DESC_AUTO_FREEZE,
  },
  {
    unit: PolicyUnit.LocationCapture,
    section: 'location',
    kind: 'location',
    nameKey: TIME_REGISTRATION_POLICY__UNIT_LOCATION_CAPTURE,
    descKey: TIME_REGISTRATION_POLICY__DESC_LOCATION_CAPTURE,
    toggleLabelKey: TIME_REGISTRATION_POLICY__FIELD_REQUIRE_LOCATION,
  },
  {
    unit: PolicyUnit.KioskAuthenticationMode,
    section: 'kiosk',
    kind: 'authMode',
    nameKey: TIME_REGISTRATION_POLICY__UNIT_KIOSK_AUTH_MODE,
    descKey: TIME_REGISTRATION_POLICY__DESC_KIOSK_AUTH_MODE,
    kiosk: true,
  },
  {
    unit: PolicyUnit.PersonalDeviceBlock,
    section: 'kiosk',
    kind: 'toggle',
    nameKey: TIME_REGISTRATION_POLICY__UNIT_PERSONAL_DEVICE_BLOCK,
    descKey: TIME_REGISTRATION_POLICY__DESC_PERSONAL_DEVICE_BLOCK,
    kiosk: true,
  },
  {
    unit: PolicyUnit.KioskModeAvailability,
    section: 'kiosk',
    kind: 'toggle',
    nameKey: TIME_REGISTRATION_POLICY__UNIT_KIOSK_AVAILABILITY,
    descKey: TIME_REGISTRATION_POLICY__DESC_KIOSK_AVAILABILITY,
    kiosk: true,
  },
];

export const getUnitDefinition = (unit: PolicyUnit): UnitDefinition | undefined =>
  UNIT_DEFINITIONS.find(def => def.unit === unit);
